import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

function SubeBilgileri() {
  const [subeData, setSubeData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubeBilgileri = async () => {
      setLoading(true);
      try {
        const subelerCollection = collection(db, 'subeler');
        const subelerSnap = await getDocs(subelerCollection);
        const subelerList = subelerSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        if (subelerList.length > 0) {
          setSubeData(subelerList);
          setError('');
        } else {
          setError('Şube bilgisi bulunamadı.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Şube bilgisi alma hatası:', err);
        setError(`Hata: ${err.message}`);
        setLoading(false);
      }
    };
    fetchSubeBilgileri();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: "'Roboto', sans-serif"
      }}>
        <p style={{ 
          fontSize: '16px', 
          color: '#4b5563', 
          fontWeight: 'bold',
          padding: '10px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
        }}>
          Yükleniyor...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: "'Roboto', sans-serif"
      }}>
        <p style={{ 
          fontSize: '16px', 
          color: '#dc2626', 
          fontWeight: 'bold',
          padding: '10px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
        }}>
          {error}
        </p>
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: '4px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      width: '90%',
      height: '650px',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      fontFamily: "'Roboto', sans-serif",
      margin: '-10px 0 4px 0'
    }}>
      <div style={{ 
        width: '90%',
        height: '650px',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <table style={{
          width: '100%',
          maxWidth: '1100px',
          borderCollapse: 'separate',
          borderSpacing: '0',
          fontSize: '16px',
          color: '#1f2937',
          lineHeight: '20px', // Satır yüksekliğini düşürdük
          boxSizing: 'border-box',
          fontWeight: 'bold',
          margin: '0 auto'
        }}>
          <thead>
            <tr>
              <th style={{ 
                border: '1px solid #e5e7eb', 
                borderRight: '1px solid #e5e7eb',
                padding: '6px', // Başlık için padding korundu
                width: '300px',
                textAlign: 'left',
                boxSizing: 'border-box',
                fontWeight: 'bold'
              }}>
                Şube Adı
              </th>
              <th style={{ 
                border: '1px solid #e5e7eb', 
                borderRight: '1px solid #e5e7eb',
                padding: '6px', // Başlık için padding korundu
                width: '600px',
                textAlign: 'left',
                boxSizing: 'border-box',
                fontWeight: 'bold'
              }}>
                Adres
              </th>
              <th style={{ 
                border: '1px solid #e5e7eb', 
                borderRight: '1px solid #e5e7eb',
                padding: '6px', // Başlık için padding korundu
                width: '200px',
                textAlign: 'center',
                boxSizing: 'border-box',
                fontWeight: 'bold'
              }}>
                Telefon
              </th>
            </tr>
          </thead>
          <tbody>
            {subeData.map((sube) => (
              <tr key={sube.id}>
                <td style={{ 
                  border: '1px solid #e5e7eb', 
                  borderRight: '1px solid #e5e7eb',
                  padding: '4px', // Satır padding'ini düşürdük
                  width: '300px',
                  boxSizing: 'border-box'
                }}>
                  {sube.ad || 'Bilinmeyen Şube'}
                </td>
                <td style={{ 
                  border: '1px solid #e5e7eb', 
                  borderRight: '1px solid #e5e7eb',
                  padding: '4px', // Satır padding'ini düşürdük
                  width: '600px',
                  boxSizing: 'border-box'
                }}>
                  {sube.adres || '-'}
                </td>
                <td style={{ 
                  border: '1px solid #e5e7eb', 
                  borderRight: '1px solid #e5e7eb',
                  padding: '4px', // Satır padding'ini düşürdük
                  width: '200px',
                  textAlign: 'center',
                  boxSizing: 'border-box'
                }}>
                  {sube.telefon || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SubeBilgileri;